// extracted by mini-css-extract-plugin
export default {"projectManage":"style_projectManage__X9-l0"};